export const environment = {
  production: false,
  api: 'https://api-dev.campoprotegido.com.ar/api',
  auth0: {
    clientId: 'UeCxBqLHd1XFR0Q3NCVneFJ8KVLpEY6W',
    domain: 'login-dev.gruposancorseguros.com',
    scope: 'email'
  }
};
